export const checkTimeSlotLoading =  ({store})  => store.checkTimeReducer.loading;

export const checkTimeSlotError =  ({store})  => store.checkTimeReducer.error;

export const checkTimeSlotData =  ({store})  => store.checkTimeReducer.data;